/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_PromoteInputs */

const en_action_promote = /** @type {(inputs: Action_PromoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promote to Moderator`)
};

const es_action_promote = /** @type {(inputs: Action_PromoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promover a Moderador`)
};

const fr_action_promote = /** @type {(inputs: Action_PromoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promouvoir Modérateur`)
};

const de_action_promote = /** @type {(inputs: Action_PromoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Moderator ernennen`)
};

const id_action_promote = /** @type {(inputs: Action_PromoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promosikan ke Moderator`)
};

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const ja_action_promote = en_action_promote;

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const zh_action_promote = en_action_promote;

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const ar_action_promote = en_action_promote;

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const it_action_promote = en_action_promote;

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const ru_action_promote = en_action_promote;

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const pt_action_promote = en_action_promote;

/** @type {(inputs: Action_PromoteInputs) => LocalizedString} */
const ko_action_promote = en_action_promote;

/**
* | output |
* | --- |
* | "Promote to Moderator" |
*
* @param {Action_PromoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_promote = /** @type {((inputs?: Action_PromoteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_PromoteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_promote(inputs)
	if (locale === "es") return es_action_promote(inputs)
	if (locale === "fr") return fr_action_promote(inputs)
	if (locale === "de") return de_action_promote(inputs)
	if (locale === "ja") return ja_action_promote(inputs)
	if (locale === "zh") return zh_action_promote(inputs)
	if (locale === "ar") return ar_action_promote(inputs)
	if (locale === "id") return id_action_promote(inputs)
	if (locale === "it") return it_action_promote(inputs)
	if (locale === "ru") return ru_action_promote(inputs)
	if (locale === "pt") return pt_action_promote(inputs)
	return ko_action_promote(inputs)
});